import React from 'react';
import TopicsAgentPage from '../components/TopicsAgentPage';
import { API_ENDPOINTS } from '../config/api';
import { loadProductTopicGroups } from '../data/productArticleTopics';

const SSArticlesAgentPage: React.FC = () => (
  <TopicsAgentPage
    pageTitle="SS Articles Agent"
    pageDescription="Generate Super Soil articles about mineral-based structure, silica-rich permanence, oxygen preservation, potting-mix decomposition, and why real soil should not rot around roots."
    storageKeyPrefix="ss_articles_agent"
    generateAsyncUrl={API_ENDPOINTS.ssArticlesGenerateAsync}
    getJobStatusUrl={API_ENDPOINTS.ssArticlesJobStatus}
    loadGroups={() =>
      loadProductTopicGroups({
        path: '/keywords/super_soil_blogs - Super Soil.csv',
        prefix: 'ss',
        leadingGroupName: 'SOIL AS STRUCTURE, NOT FERTILIZER (1-20)',
      })
    }
  />
);

export default SSArticlesAgentPage;
